import React from 'react';
import './assets/stylesheet/stylesheet.css';
import './assets/stylesheet/home.css';
import './assets/stylesheet/home-mobile.css';
import {Link} from 'react-router-dom';
import Landing from './Landing.js';
import { Helmet } from 'react-helmet';
import ScrollToTop from './ScrollToTop';

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        emailValue: '',
        fNameValue: '',
        lNameValue: '',
    };
  }

 render() {
    return (
        <div>
            <Helmet>
              <title>InertiaNYC</title>
            </Helmet>

            <Landing />

            <div className="content">

              <div className="sitting person">
                  <img src={require("./assets/images/sitting_person.png")} />
              </div>

              <div className="big2 puzzle below">
                  <img src={require("./assets/images/big_puzzle2.png")} />
              </div>

              <div className="big3 puzzle below">
                  <img src={require("./assets/images/big_puzzle.png")} />
              </div>

            {/*    <div className="standing person">
                    <img src={require("./assets/images/standing1.png")} />
                </div>

                <div className="standing2 person">
                    <img src={require("./assets/images/standing2.png")} />
                </div>
              */}

                <div id="about" className="section">
                    <div id="mission" className="text">
                        <h2 id="firstTitle" className="headerTitle">Mission</h2>
                        <p>INERTIA is a Pop-Up Instillation project coming to NYC's <a href="https://www.brooklynbridgepark.org/">Brooklyn Bridge Park</a> this summer. By changing up the traditional look and feel of STEM,
                        INERTIA works towards educating and igniting STEM interests to create greater accessibility to the STEM space.  There will be three separate installations - a wall of pink 3D-printers, a wave-like set of chairs featuring programming characters, and three chairs in the shape of gears. INERTIA aims to demystify and demonstrate the following: </p>
                        <ol>
                          <li>
                            STEM and engineering aren't simply plain and linear - it can be fun, beautiful, colorful, and, most importantly, welcoming!
                          </li>
                          <li>
                            You can be an engineer in your own right. Sometimes engineering feels daunting and exclusive. But you don’t have to build rockets or engines to be an engineer, you can be a business major and be an engineer.
                          </li>
                          <li>
                            Empowering the future of women and underestimated youth to be engineers, entrepreneurs, to chase their dreams, and create the world they want to live in. This is about empowerment, entrepreneurship, visualization, motivation, and dreams, as much as it is about engineering.
                          </li>
                        </ol>
                    </div>
                    <div className="big puzzle below">
                        <img src={require("./assets/images/big_puzzle.png")} />
                    </div>
                    <img src={require("./assets/images/staticPhoto.png")} />
                </div>

                <div id="project" className="section">
                    <div id="info" className="text projects">
                        <h2 id="secondTitle" className="headerTitle">SPACE STATION</h2>
                        <p>INERTIA is launching in NYC this summer!</p>
                        <ul>
                          <li>📍 Location: Brooklyn Bridge Park Pier 6 Brooklyn, New York</li>
                          <li>🗓 Dates: August 2021 (TBD)</li>
                          <li>⏰ Times: 8am - 10pm ET </li>
                          <li>🚀 More information coming soon!</li>
                        </ul>
                    </div>
                 </div>

                 <div id="about" className="section">
                    <div id="commInfo" className="text">
                        <h2 id="thirdTitle" className="headerTitle">Meet the Crewmates</h2>
                        <p>Team introductions coming soon. 👀</p>
                    </div>
                    <img src={require("./assets/images/community.png")} />
                </div>

                <section class="signup-section" id="signup">
                  <div class="container">
                      <div class="row">
                          <div class="col-md-10 col-lg-8 mx-auto text-center">
                              <h2 class="mb-5">Subscribe to receive updates!</h2>
                              <form action="https://nyc.us1.list-manage.com/subscribe/post?u=a5aa3643fc82c9d63b1718912&amp;id=8dd23f6ac1" method="POST" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" novalidate class="form-inline">
                                  <input type="hidden" name="u" value="eb05e4f830c2a04be30171b01"/>
                                  <input type="hidden" name="id" value="8281a64779"/>
                                    <input
                                        type="email"
                                        name="EMAIL"
                                        id="MERGE0"
                                        value={this.state.emailValue}
                                        onChange={ (e)=>{this.setState({emailValue: e.target.value});} }
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        placeholder="Enter email address.."
                                        style={{color: "black"}}
                                        class="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0"
                                     />
                                  <button class="submit-theme btn-primary btn mx-auto" type="submit" style={{color: "darkgreen", backgroundColor: "#1ae8a0", border: "#31ffa4"}}>Subscribe</button>
                                  <div style={{position: 'absolute', left: '-5000px'}} aria-hidden='true' aria-label="Please leave the following three fields empty">
                                      <label htmlFor="b_email">Email: </label>
                                      <input type="email" name="b_email" tabIndex="-1" value="" placeholder="youremail@gmail.com" id="b_email"/>
                                  </div>
                              </form>

                              <p>Contact us directly <a style={{color : "lightblue"}}href="mailto:inertianyc@gmail.com">here</a></p>
                          </div>
                      </div>
                  </div>
              </section>



            </div>

        </div>
    )
  }
}

export default HomePage;
